import { render, staticRenderFns } from "./PageItem.vue?vue&type=template&id=b045f038&"
import script from "./PageItem.vue?vue&type=script&lang=js&"
export * from "./PageItem.vue?vue&type=script&lang=js&"
import style0 from "./PageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports